// src/utils/flyToCart.js
export const flyToCart = (imageUrl, sourceEl, targetEl) => {
  if (!imageUrl || !sourceEl || !targetEl) return;

  const sourceRect = sourceEl.getBoundingClientRect();
  const targetRect = targetEl.getBoundingClientRect();

  const size = 60;
 if (navigator.vibrate) {
        navigator.vibrate(800); // vibrate for 200ms
      }
  const clone = document.createElement("img");
  clone.src = imageUrl;
  clone.style.position = "fixed";
  clone.style.top = `${sourceRect.top}px`;
  clone.style.left = `${sourceRect.left}px`;
  clone.style.width = `${size}px`;
  clone.style.height = `${size}px`;
  clone.style.borderRadius = "50%";
  clone.style.objectFit = "cover";
  clone.style.boxShadow = "0 6px 16px rgba(0,0,0,0.25)";
  clone.style.transition = "transform 0.9s cubic-bezier(0.45, 0, 0.55, 1), opacity 0.9s";
  clone.style.zIndex = 9999;
  clone.style.pointerEvents = "none";
  document.body.appendChild(clone);

  const translateX = targetRect.left - sourceRect.left;
  const translateY = targetRect.top - sourceRect.top;
  const midY = translateY - 120;

  requestAnimationFrame(() => {
    clone.animate(
      [
        { transform: "translate(0, 0) scale(1)", opacity: 1 },
        { transform: `translate(${translateX / 2}px, ${midY}px) scale(0.7)`, opacity: 0.8 },
        { transform: `translate(${translateX}px, ${translateY}px) scale(0.3)`, opacity: 0.2 },
      ],
      {
        duration: 2000,
        easing: "cubic-bezier(0.4, 0, 0.2, 1)",
        fill: "forwards",
      }
    ).onfinish = () => {
      document.body.removeChild(clone);

      // Bounce + Ripple
      targetEl.classList.add("cart-bounce");
      const ripple = document.createElement("span");
      ripple.className = "cart-ripple";
      targetEl.appendChild(ripple);
      setTimeout(() => {
        ripple.remove();
        targetEl.classList.remove("cart-bounce");
      }, 700);

      // Play sound
      const audio = new Audio("/sounds/cart-add.mp3");
      audio.play().catch(() => {});

      // Vibrate on mobile
     
    };
  });
};
